import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CusSolutionsComponent } from './components/cus-solutions/cus-solutions.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { WelcomeComponent } from '../sales-rep/components/welcome/welcome.component';
import { HomeComponent } from './components/home/home.component';
import { AvlSolutionHomeComponent } from './components/avl-solution-home/avl-solution-home.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'manage-solutions', component: CusSolutionsComponent },
  { path: 'solutions-details', component: ProductDetailsComponent },
  { path: 'available-solutions', component: AvlSolutionHomeComponent },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerHomeRoutingModule {}
